import { createContext, useContext } from 'react';

export const NetTestNowIsLoadingContext = createContext(null);
export const useNetTestNowIsLoading = () => useContext(NetTestNowIsLoadingContext);

export const NetTestNowIsLoadingProvider = NetTestNowIsLoadingContext.Provider;
export const NetTestNowIsLoadingConsumer = NetTestNowIsLoadingContext.Consumer;
